@if (slots?.slotNodesData?.header) {
  <div
    class="header-slot"
    #header
    [blazeSlotNode]="slots?.slotNodesData?.header"
    [class.sticky-mode]="isStickyHeader()"
  >
    <ng-container
      *ngTemplateOutlet="
        slots?.templates?.header || null;
        context: { elementContext: { navSection: 'header' } }
      "
    />
  </div>
}
<div class="main-slot" [blazeSlotNode]="slots?.slotNodesData?.main">
  <ng-container
    *ngTemplateOutlet="
      slots?.templates?.main || null;
      context: { elementContext: { stickySlots: stickySlots() } }
    "
  />
</div>
@if (slots?.slotNodesData?.side) {
  <div
    class="side-slot"
    #side
    [blazeSlotNode]="slots?.slotNodesData?.side"
    [class.sticky-mode]="isStickySidebar()"
    [class.full-height]="isFullHeightSidebar()"
    [class.with-sticky-header]="isStickyHeader()"
    [class.with-sticky-bottombar]="isStickyBottombar()"
    [style.--header-height.px]="headerHeight()"
    [style.--sidebar-height.px]="sidebarHeight()"
    [style.--bottombar-height.px]="bottombarHeight()"
  >
    <ng-container
      *ngTemplateOutlet="
        slots?.templates?.side || null;
        context: { elementContext: { navSection: 'side' } }
      "
    />
  </div>
}
@if (slots?.slotNodesData?.bottom) {
  <div
    class="bottom-slot"
    #bottom
    [blazeSlotNode]="slots?.slotNodesData?.bottom"
    [class.sticky-mode]="isStickyBottombar()"
  >
    <ng-container
      *ngTemplateOutlet="
        slots?.templates?.bottom || null;
        context: { elementContext: { navSection: 'bottom' } }
      "
    />
  </div>
}
